import type { LineItemElement } from "@/interfaces/line-item-elements-response";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./ui/collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useXactimateMapping } from "@/hooks/useXactimateMapping";
import { MappingDisplay } from "./MappingDisplay";
import { LineItemElementsGrid } from "./LineItemElementsGrid";

interface LineItemElementsProps {
  elements: LineItemElement[];
  selections: string[];
  updateSelection: (index: number, value: string) => void;
  lineNumber: number;
  open: boolean;
  hideHeader?: boolean;
  setOpen: (open: boolean) => void;
  className?: string;
  lineItemId: string;
}

export const LineItemElements = ({
  elements,
  selections,
  updateSelection,
  lineNumber,
  open,
  setOpen,
  className,
  hideHeader,
  lineItemId,
}: LineItemElementsProps) => {
  // Helper to get the xactimate mapping by line item string
  const { cat, selCode } = useXactimateMapping(lineItemId, selections.join(" "));

  return (
    <Collapsible open={open} onOpenChange={setOpen} className={className}>
      {!hideHeader && (
        <CollapsibleTrigger className="flex w-full items-center justify-between py-2">
          <span className="text-sm font-medium">Line {lineNumber}</span>
          {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </CollapsibleTrigger>
      )}
      <CollapsibleContent>
        <div className="flex-1 overflow-y-auto py-2 pr-2">
          <LineItemElementsGrid elements={elements} selections={selections} updateSelection={updateSelection} />
        </div>
        <MappingDisplay cat={cat} selCode={selCode} />
      </CollapsibleContent>
    </Collapsible>
  );
};
